import { Shark, Utils } from "shark-mvc";

import ViewBase from "../ViewBase";
import SiteInfoSheet from "../../_shark_models/SiteInfoSheet";

import templateContent from "./site-info-sheet-list.html";

import { activityReportComponent } from "../../_shark_jaws/components/activityReportComponent";
import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import { dateRangeFilterComponent } from "../../_shark_jaws/components/dateRangeFilter/dateRangeFilterComponent";
import exportCSVComponent from "../../components/exportCSV/exportCSVComponent";
import followUpComponent from "../../components/followUp/followUpComponent";
import getMoreComponent from "../../components/getMore/getMoreComponent";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import showAllContactsButtonComponent from "../../components/showAllContactsButton/showAllContactsButtonComponent";
import provinceFilterComponent from "../../_shark_components/provinceFilter/provinceFilterComponent";
import { siteInfoSheetActionsComponent } from "../../_shark_components/siteInfoSheetActions/siteInfoSheetActionsComponent";
import siteInfoSheetDisplayView from "./siteInfoSheetDisplayView";
import { siteInfoSheetManager } from "../../_shark_jaws/managers/siteInfoSheetManager";
import siteInfoSheetOutdoorDisplayView from "./siteInfoSheetOutdoorDisplayView";
import { userManager } from "../../_shark_jaws/managers/userManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

// Dave: devo aggiungere un tasto per richiamare la gestione della richiesta solvilità dalla lista
import setClientSolvencyStatusView from "./setClientSolvencyStatusView";
 

class SiteInfoSheetListView extends ViewBase {
	constructor () {
		super("siteInfoSheetListView");
		this.setTemplate(templateContent);
	}

	addQuotationBtn_clickHandler (event, data) {
		const { siteInfoSheetList } = Shark.get();
		const currSiteInfoSheet = Utils.safp(siteInfoSheetList, "guid", data.guid);
	
		if (currSiteInfoSheet && (!currSiteInfoSheet.__quotation_pending && !currSiteInfoSheet.__quotation_uploaded)) {
			Shark.set({currSiteInfoSheet});
			siteInfoSheetActionsComponent.show();
		}
	}

	beforeLoad () {
		window.scrollTo(0, 0);

		const siteInfoSheetList = Shark.get("siteInfoSheetList");
		
		activityReportComponent.set("__reportType", "schede informative");
		liveSearchComponent.behavior = "database";
		followUpComponent.set("targetItem", null);
	
		if (Shark.get("agentList").length === 0) {
			userManager.getList();
		}
	
		if (Shark.get("clientList").length === 0) {
			clientManager.getList();
		}	
	
		userManager.getRequireAttentionCounts();//Dave: Avremo le notifiche per aggiornare questi numeri

		this.set({
			__htmlTitle: "Schede Informative | IPM HUB"
		});
	
		if (siteInfoSheetList.length === 0 || Shark.get("refreshSiteInfoSheetListNeeded")) {
			Shark.set({
				refreshSiteInfoSheetListNeeded: false,
			});
			this.refreshList(null, true);
		}
		else {
			// Dave.Info: Se ho già una lista faccio un refresh "default" > carica solo se ci sono filtri diversi (es la provincia.)
			this.refreshList();
		}
	}

	// Dave: questa, in futuro, non dovrebbe più servire...
	async checkFolder (guid) {
		const result = await siteInfoSheetManager.checkFolders(guid);
		console.log({result});
		alert("Guarda il risultato nella console");
	}

	deleteSiteInfoSheet (siteInfoSheet) {
		const deleteReason = prompt("Inserisci il motivo per cui vuoi cancellare questa Scheda Informativa (obbligatorio)");

		if (deleteReason && deleteReason.trim() !== "") {
			waitBoxComponent.open();

			//sisName dovrebbe essere calcolato lato API
			let sisName = "";

			if (siteInfoSheet.registry.siteLocation.name.trim() !== "") {
				sisName = siteInfoSheet.registry.siteLocation.name;
			}
			else {
				sisName = "Sede Legale";
			}

			sisName += (siteInfoSheet.registry.siteLocation.interventionAreas ? " - " + siteInfoSheet.registry.siteLocation.interventionAreas : "");

			siteInfoSheetManager.delete(siteInfoSheet, deleteReason, sisName)
			.then(deleteResult => {
				console.log({deleteResult});
				waitBoxComponent.close();
				this.refreshList();
			});
		}
	}

	deleteSiteInfoSheetBtn_clickHandler (event, data) {
		if (confirm("Sei sicuro di voler cancellare questa Scheda Informativa?\n\nSe prosegui non sarà possibile annullare!")) {
			const siteInfoSheet = Utils.safp(Shark.get("siteInfoSheetList"), "guid", data.guid);
			
			if (siteInfoSheet) {
				this.deleteSiteInfoSheet(siteInfoSheet);
			}
		}
	}

	getSiteInfoSheetByGuid (guid) {
		const siteInfoSheetList = Shark.get("siteInfoSheetList");
		const currSiteInfoSheet = Utils.safp(siteInfoSheetList, "guid", guid);

		return currSiteInfoSheet;
	}

	init () {
		//Dave: Qui sotto ho dovuto aggiungere "exportCSVComponent" perché è richiesto dal activityReportComponent e sebbene i metodi sarebbero gestiti, non parsa il template e manca il tasto.
		this.addComponents([activityReportComponent, agentFilterComponent, dateRangeFilterComponent, exportCSVComponent, followUpComponent, getMoreComponent, liveSearchComponent, mainNavComponent, provinceFilterComponent, refreshListButtonComponent, showAllContactsButtonComponent, siteInfoSheetActionsComponent, waitBoxComponent]);

		const filtersStatus = this.getFiltersStatus();

		const siteInfoSheetListActiveFilters = Shark.getInstance("__smart__", {
			sentCount: 0,
			showAllContacts: filtersStatus ? filtersStatus.showAllContacts : false,
			showInStandBy: filtersStatus ? filtersStatus.showInStandBy : true,
			showSent: filtersStatus ? filtersStatus.showSent : false,
			showUploaded: filtersStatus ? filtersStatus.showUploaded : true,
			showWaiting: filtersStatus ? filtersStatus.showWaiting : true,
			uploadedCount: 0,
			waitingCount: 0,
		});

		siteInfoSheetListActiveFilters.on("dataChanged", function (event, data) {
			siteInfoSheetListView.saveFiltersStatus(this);
			
			// "showAllContacts" modifica solo i dati mostrati, non serve richiedere al DB.
			if (data.property === "showAllContacts") {
				Shark.render();
			}
			else {
				if (this.showInStandBy || this.showSent || this.showUploaded || this.showWaiting) {
					siteInfoSheetListView.refreshList();
				}
				else {
					Shark.set({
						siteInfoSheetList: [],
						__siteInfoSheetListNeedFurtherLoad: false,
					});
			
					Shark.render();
				}
			}
		});

		getMoreComponent.views[this.className] = {
			currentPage: 0,
		};

		Shark.set({
			agentList: Shark.get("agentList") || [],
			clientList: Shark.get("clientList") || [],
			siteInfoSheetList: Shark.get("siteInfoSheetList") || [],
			siteInfoSheetListActiveFilters
		});

		this.set({
			__htmlTitle: "Schede Informative | IPM HUB"
		});
	}

	refreshList (range = null, force = false) {
		waitBoxComponent.show();

		let incrementalRequest = false;

		if (!range) {
			getMoreComponent.views[this.className] = {
				currentPage: 0,
			};
			range = getMoreComponent.getCurrentPageRangeForView(this.className);
		}
		else {
			incrementalRequest = true;
		}

		const { agentFilter, dateRangeFilter, provinceFilter, siteInfoSheetListActiveFilters } = Shark.get();
		const filters = siteInfoSheetListActiveFilters.export();

		delete filters.sentCount;
		delete filters.uploadedCount;
		delete filters.waitingCount;

		if (provinceFilter.province !== "all") {
			filters.province = provinceFilter.province;
		}

		if (agentFilter.agentGuid !== "") {
			filters.agentGuid = agentFilter.agentGuid;
		}

		if (!dateRangeFilter.ignoreDateRange) {
			filters.dateFrom = dateRangeFilter.__from;
			filters.dateTo = dateRangeFilter.__to;
		}

		if (this.textFilters) {
			Object.assign(filters, this.textFilters);
		}

		// Dave.ToDo: Portare tutto in una funzione, lo faccio ovunque!
		if (!force) {
			if (localStorage.siteInfoSheetListViewLastFilters) {
				if (localStorage.siteInfoSheetListViewLastFilters === JSON.stringify({filters, range})) {
					refreshListButtonComponent.resetStatus();
					waitBoxComponent.hide();
					return;
				}
			}
		}
		
		return siteInfoSheetManager.getFilteredList({filters, range, incrementalRequest})
		.then(response => {
			localStorage.siteInfoSheetListViewLastFilters = JSON.stringify({filters, range});

			const provinceForFilterComponentSet = new Set();
			response.data.forEach(item => provinceForFilterComponentSet.add(item.registry.clientProvince));
	
			//Dave: Spostalo nel componente
			let provinceForFilterComponent = Array.from(provinceForFilterComponentSet);
			provinceForFilterComponent.sort();
			provinceForFilterComponent = provinceForFilterComponent.map(item => item.trim() !== "" ? {label: item, value: item} : {label: "- Non impostata", value: ""});
	
			waitBoxComponent.hide();
			Shark.set({provinceForFilterComponent});
			Shark.render();
			return true;
		});
	}

	siteInfoSheetActionBtn_clickHandler (event, data) {
		const currSiteInfoSheet = this.getSiteInfoSheetByGuid(data.guid);
		console.log({currSiteInfoSheet});

		if (currSiteInfoSheet) {
			switch(data.action) {
				case "checkFolder":
					this.checkFolder(data.guid);
					break;
				case "delete":
					if (confirm("Sei sicuro di voler cancellare questa Scheda Informativa?\n\nSe prosegui non sarà possibile annullare!")) {
						this.deleteSiteInfoSheet(currSiteInfoSheet);
					}
					break;
				case "setStatusToStandBy":
					if (![SiteInfoSheet.STATUS_NEW, SiteInfoSheet.STATUS_READY].includes(currSiteInfoSheet.status)) {
						alert("Non puoi cambiare lo status di questa Scheda Informativa.");
						return;
					}
					if (confirm("Sei sicuro di voler impostare lo Status di questa Scheda Informativa a 'Da completare'?\n\nSe procedi non potrai annullare!")) {
						const reason = prompt("Per favore indica un motivo per questa modifica");

						waitBoxComponent.open();

						siteInfoSheetManager.revertStatus(currSiteInfoSheet, SiteInfoSheet.STATUS_STAND_BY, reason || "")
						.then(() => {
							waitBoxComponent.close();
							this.refreshList();
						});
					}
					break;
			}
		}
	}

	updateTextFilters (searchKey) {
		if (searchKey && searchKey !== "") {
			this.textFilters = {
				name: searchKey,
				quotationCCA: searchKey,
				quotationNumber: searchKey,
				searchKey,
			};
		}
		else {
			this.textFilters = null;
		}

		this.refreshList()
		.then(() => {
			if (searchKey !== "") {
				liveSearchComponent.setFocus();
			}
		});
	}

	viewClientSolvencyRequest (siteInfoSheet) {
		Shark.openPage(setClientSolvencyStatusView, { urlSearchParams: { sisg: siteInfoSheet.guid }});
	}

	viewClientSolvencyRequestBtn_clickHandler (event, data) {
		const { siteInfoSheetList } = Shark.get();
		const currSiteInfoSheet = Utils.safp(siteInfoSheetList, "guid", data.guid);

		if (currSiteInfoSheet) {
			this.viewClientSolvencyRequest(currSiteInfoSheet);
		}
	}





		
	afterComponentsPreRender () {
		const currUser = Shark.get("currUser");
		let siteInfoSheetList = Shark.get("siteInfoSheetList");

		if (siteInfoSheetList) {
			// const [agentFilter, dateRangeFilter, provinceFilter, siteInfoSheetListActiveFilters] = Shark.get(["agentFilter", "dateRangeFilter", "provinceFilter", "siteInfoSheetListActiveFilters"]);
			let counter = 0;
			let showDateRangeInfo = false;

			siteInfoSheetList.forEach((item) => {
				// if (item.__render && agentFilter.agentGuid !== "" && agentFilter.agentGuid !== item.userGuid) {
				// 	item.__render = false;
				// 	item.__renderReason = "agentFilter";
				// }

				// if (item.__render && provinceFilter.province !== "all" && provinceFilter.province !== item.registry.clientProvince) {
				// 	item.__render = false;
				// 	item.__renderReason = "provinceFilter";
				// }

				//Dave: Ecco, questo è il caso perfetto in cui il ModelRenderer dovrebbe fare il suo lavoro...
				if (!dateRangeFilterComponent.includeDate(item.__referenceDate) && dateRangeFilterComponent.includeDate(item.__updatedAt)) {
					item.__updatedAtDateLabel = "<span class=\"filter-matched-field-display\">" + item.__updatedAtLabel + "</span>";
					showDateRangeInfo = true;
				}
				else {
					item.__updatedAtDateLabel = item.__updatedAtLabel;
				}

				item.__render = true;
				item.__displayIndex = counter + 1;
				counter++;

				//Dave: Da spsotare su API
				if (!item.additionalNotes.siteClientSolvencyRequested && currUser.hasPermission("manageClientSolvencyRequest") && !currUser.hasPermission("manageSiteInfoSheet", "viewSiteInfoSheet")) {
					item.__render = false;
				}
			});

			this.set({
				__showDateRangeInfo: showDateRangeInfo,
			});
		}
		
		console.time("activityReportComponent.extractReport");
		Shark.set({ activityReport: activityReportComponent.extractReport(siteInfoSheetList) });
		console.timeEnd("activityReportComponent.extractReport");
	}


	beforeRender () {
		const siteInfoSheetList = Shark.get("siteInfoSheetList");

		followUpComponent.set({
			sourceList: siteInfoSheetList
		});
	}


	showQuotationInfoBtn_clickHandler (event, data) {
		const siteInfoSheetList = Shark.get("siteInfoSheetList");
		const currSiteInfoSheet = Utils.safp(siteInfoSheetList, "guid", data.guid);
		const quotationData = currSiteInfoSheet.extraData.quotation;

		alert(`CCA: ${quotationData.cca}\nNumero Preventivo: ${quotationData.number}\nData Preventivo: ${quotationData.date}`);
	}

	singleItemBox_clickHandler (event, data) {
		if (event.target.closest(".preventRowClick") !== null) {
			return;
		}

		if (event.target.classList.contains("notClickable")) {
			return;
		}

		const currSiteInfoSheet = Utils.safp(Shark.get("siteInfoSheetList"), "guid", data.guid);

		if (currSiteInfoSheet) {
			Shark.set({
				currSiteInfoSheet,
				isEditingSiteInfoSheet: false,
			});
			followUpComponent.set("targetItem", currSiteInfoSheet);
			// Shark.openPage(siteInfoSheetDisplayView);
			if (currSiteInfoSheet.type === "industrial") {
				Shark.openPage(siteInfoSheetDisplayView);
			}
			else {
				Shark.openPage(siteInfoSheetOutdoorDisplayView);
			}
		
			window.scrollTo(0, 0);
		}
	}

	siteInfoSheetManager_savedHandler () {
		console.log("QQQQQQQQQQQQQQQQQQQQQQQQQQQQQUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII!!!!!!!!!!!!!!!!!!!!!!!!");
		console.log("QQQQQQQQQQQQQQQQQQQQQQQQQQQQQUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII!!!!!!!!!!!!!!!!!!!!!!!!");
		console.log("QQQQQQQQQQQQQQQQQQQQQQQQQQQQQUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII!!!!!!!!!!!!!!!!!!!!!!!!");
		console.log("QQQQQQQQQQQQQQQQQQQQQQQQQQQQQUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII!!!!!!!!!!!!!!!!!!!!!!!!");
		Shark.render();
	}
}

const siteInfoSheetListView = new SiteInfoSheetListView();

Shark.registerView(siteInfoSheetListView);

export default siteInfoSheetListView;
